/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import {
  IconMinusCircle, IconSuccess, IconProcessing, IconWarning,
  IconProps, IconDeclined,
} from '@americanexpress/dls-icons';
import { renderHtml } from '../utils/render-html';
import { MembershipTextBadge } from '@americanexpress/web-react-extensions';

interface Props {
  enrolledStatus: any;
  enrollmentApplicationStatus: string,
  label: string,
  labelClass?: string;
}

interface StatusIconProps {
  size: IconProps['size'],
  color: IconProps['color'],
  isFilled: IconProps['isFilled'],
  className: string,
}

const IconCommonProps: StatusIconProps = {
  size: 'md',
  className: '',
  color: 'neutral',
  isFilled: true,
};

const mapping = {
  notenrolled: {
    iconComponent: () => <IconMinusCircle {...IconCommonProps} color="neutral" />,
    status: 'information',
  },
  enrolled: {
    iconComponent: () => <IconSuccess {...IconCommonProps} color="success" />,
    status: 'success',
  },
  pending: {
    iconComponent: () => <IconProcessing {...IconCommonProps} color="neutral" />,
    status: 'attention',
  },
  rejected: {
    iconComponent: () => <IconWarning {...IconCommonProps} color="neutral" />,
    status: 'warning',
  },
  cancelled: {
    iconComponent: () => <IconDeclined {...IconCommonProps} color="neutral" />,
    status: 'attention',
  },
  with_provider: {
    iconComponent: () => <IconProcessing {...IconCommonProps} color="neutral" />,
    status: 'information',
  },
  unavailable: {
    iconComponent: () => <IconWarning {...IconCommonProps} color="critical" />,
    status: 'warning',
  },
  failed: {
    iconComponent: () => <IconWarning {...IconCommonProps} color="critical" />,
    status: 'warning',
  },
  notloggedin: {
    iconComponent: () => <IconMinusCircle {...IconCommonProps} color="neutral" />,
    status: 'information',
  },
};

const EnrollStatus = (props: Props): JSX.Element => {
  const enrollmentApplicationStatus = props?.enrollmentApplicationStatus;
  const enrollmentStatus = enrollmentApplicationStatus in mapping ? enrollmentApplicationStatus : 'notloggedin';

  const label = props?.label;
  const labelClass = props?.labelClass ?? '';
  const enrolledStatus = props?.enrolledStatus;
  const iconComponent = mapping[enrollmentStatus].iconComponent;
  const status = mapping[enrollmentStatus].status;

  const showEnrollStatus = useMemo(() => {
    const badgeCommonProps = {
      className: "",
      innerContainerClassName: "",
      screenReaderLabel: label,
      size: "small",
      icon: iconComponent(),
      status: status,
    }
    return (
      <MembershipTextBadge
        {...badgeCommonProps}
      >
        {renderHtml(label, labelClass)}
      </MembershipTextBadge>
    );
  }, [label, enrolledStatus]);

  return (
    <section className="flex flex-row" data-testid="enroll-status">
      {showEnrollStatus}
    </section>
  );
};

export default EnrollStatus;
